module.exports = __webpack_public_path__ + "img/pen.be5030ca.webp";